import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import { getAuthorities } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/student-report/StudentReportAction";
import * as uiHelpers from "../RegistrationCancellationReportUIHelpers";
import {
  getHandlerTableChange,  
  getSelectRow,  
  NoRecordsFoundMessage,
  PleaseWaitMessage
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useRegistrationCancellationReportUIContext } from "../RegistrationCancellationReportUIContext";
import { FilterButtonsTable } from "./FilterButtonsTable";

export function RegistrationCancellationReportTable({
  activateRegistration,
  deleteStudents
}) {
  // Registration Cancellation Report UI Context
  const cancellationReportUIContext = useRegistrationCancellationReportUIContext();
  const cancellationReportUIProps = useMemo(() => {
    return {
      ids: cancellationReportUIContext.ids,
      setIds: cancellationReportUIContext.setIds,
      columns: cancellationReportUIContext.columns,
      queryParams: cancellationReportUIContext.queryParams,
      setQueryParams: cancellationReportUIContext.setQueryParams
    };
  }, [cancellationReportUIContext]);

  // Getting curret state of Registration Cancellation Report from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.studentReport }),
    shallowEqual
  );
  const { totalCount, entities, authorities, listLoading } = currentState;

  // Authority Parameters
  const { isEditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);

  // Registration Cancellation Report Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getRegistrationCancellationReport(cancellationReportUIProps.queryParams));
    return () => dispatch(actions.cleanStudentReportState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cancellationReportUIProps.queryParams, dispatch]);

  if (isEditionAuthorized || isDeletionAuthorized) {
    cancellationReportUIProps.columns.forEach(column => {
      if (column["dataField"] === "action") {
        column.hidden = false;
        column.formatter = columnFormatters.ActionsColumnFormatter;
        column.formatExtraData = {
          isEditionAuthorized,
          isDeletionAuthorized,
          activateRegistration,
          deleteStudents
        };
      }
    });
  }
  
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: cancellationReportUIProps.queryParams.pageSize,
    page: cancellationReportUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <FilterButtonsTable />
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ?? [] }
              columns={cancellationReportUIProps.columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                cancellationReportUIProps.setQueryParams
              )}
              selectRow={getSelectRow({
                entities,
                ids: cancellationReportUIProps.ids,
                setIds: cancellationReportUIProps.setIds,
                hidden: !isDeletionAuthorized
              })}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>
  );
}